import { Component } from '@angular/core';

@Component({
  selector: 'app-home-layout',
  template: `
    <app-header></app-header>
    <app-sidebar></app-sidebar>
    <app-body>
      <router-outlet></router-outlet>
    </app-body>
  `,
  styles: []
})
export class HomeLayoutComponent {}